import { ImageLoader } from 'components/common';
import PropType from 'prop-types';
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useHistory } from 'react-router-dom';
import { displayMoney, displayAddress } from 'helpers/utils';

const ProductFeatured = ({ product }) => {
  const history = useHistory();
  const onClickItem = () => {
    if (!product) return;

    history.push(`/product/${product.id}`);
  };

  return (
    <SkeletonTheme color="#e1e1e1" highlightColor="#f2f2f2">
      <div
        className="product-display"
        onClick={onClickItem}
        role="presentation"
      >
        <div className="product-display-img">
          {product.image ? (
            <ImageLoader className="product-card-img" src={product.image} />
          ) : (
            <Skeleton width="100%" height="100%" />
          )}
        </div>
        <div className="product-display-details">
          <h3 className="product-text-truncate">
            {product.name || <Skeleton width={80} />}
          </h3>
          <p className="text-subtle text-italic product-text-truncate">
            {displayAddress(product) || <Skeleton width={20} />}
          </p>
          <h3>{displayMoney(product) || <Skeleton width={80} />}</h3>
        </div>
      </div>
    </SkeletonTheme>
  );
};

ProductFeatured.propTypes = {
  product: PropType.shape({
    image: PropType.string,
    name: PropType.string,
    id: PropType.string,
    price: PropType.number,
    dateAdded: PropType.number,
    address: PropType.shape({
      province: PropType.string,
      region: PropType.string,
      municipality: PropType.string
    })
  }).isRequired
};

export default ProductFeatured;
